import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, clearToken, getToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [status, setStatus] = useState("checking");

    const refresh = useCallback(async () => {
        const t = getToken();
        if (!t) {
            setUser(null);
            setStatus("guest");
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            setStatus("authed");
        } catch {
            clearToken();
            setUser(null);
            setStatus("guest");
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            setToken(data.token);
            setUser(data.user);
            setStatus("authed");
            return { ok: true };
        } catch (err) {
            return { ok: false, error: formatApiError(err, "Login failed.") };
        }
    };

    const logout = () => {
        clearToken();
        setUser(null);
        setStatus("guest");
    };

    return (
        <AuthContext.Provider value={{ user, status, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
};
